import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { MirrorService } from 'services/MirrorService';
import { SexualOrientation } from 'types/enums/SexualOrientation';
import { UserGender } from 'types/enums/UserGender';

import { CaseId, TDSApi } from 'api/TDSApi';
import { decodeBase64 } from 'helpers/base64';
import { getUserIdFromCookies } from 'helpers/userId';
import { useInitialId } from 'hooks/useInitialId';
import { useSystemSearchQueries } from 'hooks/useSystemSearchQueries';

import { FullscreenSpinner } from 'components/shared/FullscreenSpinner';

const MF_FEATURE_KEY = 'jho63s';

export const TDSEntryPage = () => {
  const history = useHistory();

  const { getInitialId, setInitialIdToCookie } = useInitialId();

  const {
    getMFQuery,
    getUserDataQuery,
    getReqCidQuery,
    getPartnerIdQuery,
    getEventDataIdQuery,
    getClickIdQuery,
  } = useSystemSearchQueries();

  const isNonTargetTrafficEnabled = getMFQuery().value === MF_FEATURE_KEY;

  const handleRedirect = (
    redirect: string,
    stateData?: { [key: string]: any }
  ) => {
    const url = new URL(redirect);

    if (url.hostname === MirrorService.domain) {
      history.push({
        pathname: url.pathname,
        search: url.search,
        state: {
          ...stateData,
        },
      });
    } else {
      window.location.href = redirect;
    }
  };

  const fetchRedirectUrl = async () => {
    try {
      const {
        redirect,
        case_id: caseId,
        is_buyer: isBuyer,
      } = await TDSApi.fetchRedirectUrl();

      const { value: userData } = getUserDataQuery();

      if (caseId === CaseId.CustomPage) {
        history.push('/entry/click', {
          redirectUrl: redirect,
        });

        return;
      }

      if (!isBuyer && userData && isNonTargetTrafficEnabled) {
        const { gender, sexual_orientation: orientation } =
          decodeBase64(userData);
        const { value: reqCid } = getReqCidQuery();
        const { value: partnerId } = getPartnerIdQuery();
        const { value: eventDataId } = getEventDataIdQuery();
        const { value: clickId } = getClickIdQuery();

        if (getUserIdFromCookies()) {
          history.push('/');

          return;
        }

        if (orientation && orientation === SexualOrientation.homo) {
          handleRedirect(
            `https://parmentscommails.com/7aedd34b-bf3a-47e5-9f17-0ad426cccc51?orientation=${orientation}&req_cid=${reqCid}&partner_id=${partnerId}&partner_login_id=96&event_data_id=${eventDataId}&click_id=${clickId}&placement=redirect`
          );

          return;
        }

        if (gender && gender === UserGender.Female) {
          handleRedirect(
            `https://parmentscommails.com/2d71c640-4d3a-4ed8-8937-81e47a62ad15?gender=${gender}&req_cid=${reqCid}&partner_id=${partnerId}&partner_login_id=96&event_data_id=${eventDataId}&click_id=${clickId}&placement=redirect`
          );

          return;
        }

        handleRedirect(redirect);

        return;
      }
      handleRedirect(redirect);
    } catch (err) {
      history.push('/');
    }
  };

  useEffect(() => {
    getInitialId()
      .then(setInitialIdToCookie)
      .then(fetchRedirectUrl)
      .catch(() => {
        history.push({
          pathname: '/',
          search: window.location.search,
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <FullscreenSpinner />;
};
